export const PER_DIEM_JOB = 'Per Diem';
export const CONTRACT_JOB = 'Contract';
export const PERMANENT_JOB = 'Permanent';